import { render } from "./CreatePBXGroup.vue?vue&type=template&id=09d06194"
import script from "./CreatePBXGroup.vue?vue&type=script&lang=js"
export * from "./CreatePBXGroup.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__